import type { MutableRefObject } from "react";
import { Grid, FormControl, FormLabel } from "@mui/joy";
import DarkInput from "../../../common/DarkInput";
import type { TrainingTemplate } from "../../../../api/training/Training.typed";

type Props = {
  selected: TrainingTemplate;
  inputRefs: MutableRefObject<{ [key: string]: HTMLInputElement | null }>;
  onFieldWithFocus: (
    field: keyof Omit<TrainingTemplate, "ID">,
    value: string | number | boolean,
  ) => void;
};

export default function TrainingTemplateOrganisationFields(props: Props) {
  const { selected, inputRefs, onFieldWithFocus } = props;

  return (
    <>
      <Grid xs={12}>
        <FormControl>
          <FormLabel>Organisation</FormLabel>
          <DarkInput
            ref={(element) => {
              inputRefs.current.Agency = element;
            }}
            value={selected.Agency}
            onChange={(event) => onFieldWithFocus("Agency", event.target.value)}
            fullWidth
          />
        </FormControl>
      </Grid>
      <Grid xs={12}>
        <FormControl>
          <FormLabel>Qualification</FormLabel>
          <DarkInput
            ref={(element) => {
              inputRefs.current.Qualification = element;
            }}
            value={selected.Qualification}
            onChange={(event) => onFieldWithFocus("Qualification", event.target.value)}
            fullWidth
          />
        </FormControl>
      </Grid>
    </>
  );
}
